import { render, staticRenderFns } from "./LifeSmartSetting.vue?vue&type=template&id=5b3c3d74&scoped=true"
import script from "./LifeSmartSetting.vue?vue&type=script&lang=js"
export * from "./LifeSmartSetting.vue?vue&type=script&lang=js"
import style0 from "./LifeSmartSetting.vue?vue&type=style&index=0&id=5b3c3d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c3d74",
  null
  
)

export default component.exports